module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Home.8a5e9aaa.gif";